
import { css } from 'lit';
export default css`
pc-featured-grid [slot='grid-item']{
    border-bottom:2px solid var(--purple-medium-neutral);
  }


pc-featured-grid[pin-featured] [slot='grid-item']:first-child{
    --heading-font-size-mobile:var(--fs-h6-mobile);
    --heading-font-size:var(--fs-h6);
  }


@media (min-width: 992px){


pc-featured-grid[pin-featured] [slot='grid-item']:first-child{
      grid-row:span 2;
      --heading-font-size:var(--fs-h2)
  }
    }


pc-featured-grid[pin-featured] [slot='grid-item'] h3, pc-featured-grid[pin-featured] [slot='grid-item'] a{
      line-height:100%;
    }


pc-featured-grid[pin-featured] [slot='grid-item']:first-child,
  pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(2),
  pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(3),
  pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(4),
  pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(5){
    display:flex;
    flex-direction:column;
    padding:2rem 0;
  }


@media (min-width: 992px){


pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(4),
  pc-featured-grid[pin-featured] [slot='grid-item']:nth-child(5){
      border-top:0;
      padding-top:0
  }
    }


pc-featured-grid:not([pin-featured]) [slot='grid-item']{
    width:100%;
  }
`;